import React, { useEffect, useRef, useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useColorScheme } from '@mui/material/styles';

import mermaid from 'mermaid';

import { KnzComponentProps } from '../../types';

let mermaidInitialized = false;
let renderSeq = 0;

/**
 * Mermaid 図（knz 独自の新規コンポーネント）。
 * params: text（raw, mermaid 定義）
 * securityLevel: 'strict' で script 実行を防ぐ。
 */
export const Mermaid: React.FC<KnzComponentProps> = ({ node }) => {
  const code = (node.params.text as string) ?? '';
  const { mode, systemMode } = useColorScheme();
  const resolved = mode === 'system' ? systemMode : mode;
  const isDark = resolved === 'dark';

  const [svg, setSvg] = useState<string>('');
  const [error, setError] = useState<string>('');
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    mermaid.initialize({
      startOnLoad: false,
      securityLevel: 'strict',
      theme: isDark ? 'dark' : 'default',
    });
    mermaidInitialized = true;

    let cancelled = false;
    const id = `knz-mermaid-${renderSeq++}`;
    mermaid
      .render(id, code)
      .then(({ svg: rendered }) => {
        if (!cancelled) {
          setSvg(rendered);
          setError('');
        }
      })
      .catch((e: unknown) => {
        if (!cancelled) {
          setError(e instanceof Error ? e.message : '図の描画に失敗しました');
          setSvg('');
        }
      });

    return () => {
      cancelled = true;
    };
  }, [code, isDark]);

  if (error) {
    return (
      <Box sx={{ border: 1, borderColor: 'error.main', borderRadius: 2, p: 2 }}>
        <Typography variant="caption" color="error">
          Mermaid 図の描画エラー: {error}
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      ref={containerRef}
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 2,
        p: 2,
        textAlign: 'center',
        overflow: 'auto',
      }}
      // mermaid の出力は securityLevel:'strict' でサニタイズ済み
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
};

export default Mermaid;

// 参照されない変数の未使用警告回避（初期化フラグは将来の最適化用に保持）
void mermaidInitialized;
